// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Js_dict from "../../../../../node_modules/rescript/lib/es6/js_dict.js";

function getVehicleCategoryFromId(id) {
  switch (id) {
    case "91" :
        return /* ThreeWheeler */1;
    case "97" :
        return /* TwoWheeler */0;
    default:
      return /* Trucks */2;
  }
}

function getVehicleCategory(url_params) {
  var id = Js_dict.get(url_params, "vehicle_id");
  if (id !== undefined) {
    return getVehicleCategoryFromId(id);
  } else {
    return /* Trucks */2;
  }
}

export {
  getVehicleCategoryFromId ,
  getVehicleCategory ,
  
}
/* No side effect */
